/* RESPONSIBLE TEAM: team-standalone */
import type HandoffToSalesforceChat from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-chat';
import StepConfig, { type StepConfigParams } from '../step';

export default class HandoffToSalesforceChatConfiguration extends StepConfig {
  declare step: HandoffToSalesforceChat;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-salesforce-chat',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
